import React from "react";
import { VMBuilder } from "../../../commons/base/providers/builder";
import FormOpsReminderListViewModel from "../view_models/form_ops_reminder_list_view_model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEraser,
    faEye,
    faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";

export default class FormOpsReminderTableWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<FormOpsReminderListViewModel>>
                {(vm) => (
                    <div className="overflow-x-auto">
                        <table className="table-fixed w-full text-center border-collapse">
                            <thead>
                                <tr className="bg-gray-300">
                                    <th className="p-2 border border-gray-400 w-1/4">
                                        ID
                                    </th>
                                    <th className="p-2 border border-gray-400 w-1/4">
                                        Title
                                    </th>
                                    <th className="p-2 border border-gray-400 w-1/4">
                                        Outlet Type
                                    </th>
                                    <th className="p-2 border border-gray-400 w-1/4">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {vm.filteredForms ? (
                                    vm.filteredForms.map((form) => (
                                        <tr
                                            key={form.id}
                                            className="bg-white hover:bg-gray-100 transition"
                                        >
                                            <td className="p-2 border border-gray-400">
                                                {form.id}
                                            </td>
                                            <td className="p-2 border border-gray-400">
                                                {form.title}
                                            </td>
                                            <td className="p-2 border border-gray-400">
                                                {form.outletType}
                                            </td>
                                            <td className="p-2 border border-gray-400">
                                                <button
                                                    className="px-1 py-1 mx-1 rounded-md bg-purple-500 hover:bg-purple-700 text-white"
                                                    onClick={() =>
                                                        (window.location.href = `/form-ops-reminder/update/${form.id}`)
                                                    } // cant use Navigate because of class component
                                                >
                                                    Lihat Detail
                                                    <FontAwesomeIcon
                                                        className="mx-3"
                                                        icon={faEye}
                                                    />
                                                </button>
                                                <button
                                                    className="px-1 py-1 mx-1 rounded-md bg-blue-500 hover:bg-blue-700 text-white"
                                                    onClick={() =>
                                                        vm.openModalForSendOnce(
                                                            form.id
                                                        )
                                                    }
                                                >
                                                    Kirim Sekali
                                                    <FontAwesomeIcon
                                                        className="mx-3"
                                                        icon={faPaperPlane}
                                                    />
                                                </button>
                                                <button
                                                    className="px-1 py-1 mx-1 rounded-md bg-red-500 hover:bg-red-700 text-white"
                                                    onClick={() =>
                                                        vm.deleteForm({
                                                            formId: form.id,
                                                            onSuccess: () =>
                                                                vm.fetchFormsList(),
                                                        })
                                                    }
                                                >
                                                    Hapus
                                                    <FontAwesomeIcon
                                                        className="mx-3"
                                                        icon={faEraser}
                                                    />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <h1>Loading</h1>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
